import useApiMutation from 'shared/hooks/use-api-mutation';
import useInfiniteQueryHelpers from 'shared/hooks/use-infinite-query-helpers';
import {NeighborhoodProps, translatedNeighborhoodProps} from '../types';
import {TranslatedKeys} from 'shared/types/translated-keys';
import neighborhoodsKeys from '../util/neighborhoods-keys';
import useQueryHelpers from 'shared/hooks/use-query-helpers';
import citiesKeys from 'modules/cities/util/cities-keys';

export interface CreateNeighborhoodProps
  extends Omit<NeighborhoodProps, 'id' | 'city'> {
  cityId: string;
}

export const translatedCreateNeighborhoodProps: TranslatedKeys<CreateNeighborhoodProps> =
  {
    ...translatedNeighborhoodProps,
    cityId: 'Cidade',
  };

const useCreateNeighborhood = (goToCitiesModule?: boolean) => {
  const {create} = useInfiniteQueryHelpers();
  const queryHelpers = useQueryHelpers();

  const onSuccess = (data: NeighborhoodProps) => {
    create(neighborhoodsKeys.list(), data);

    const cityNeighborhoods = queryHelpers.getData(
      citiesKeys.neighborhoods(data.cityId),
    );

    if (cityNeighborhoods)
      queryHelpers.create(citiesKeys.neighborhoods(data.cityId), data);
  };

  return useApiMutation<NeighborhoodProps>({
    url: '/neighborhoods',
    method: 'POST',
    errorTitle: 'Erro ao cadastrar bairro',
    successTitle: 'Cadastrar bairro',
    successMessage: 'Bairro cadastrado com sucesso',
    redirectUrl: (data) =>
      goToCitiesModule
        ? `/settings/cities/${data.cityId}/neighborhoods`
        : '/settings/neighborhoods',
    onSuccess,
  });
};

export default useCreateNeighborhood;
